import * as api from '../api';
import axios from 'axios';

export const DownloadInvoice = (p_URL) => {
    // download binary data for invoices
    return (
        axios({
            url: p_URL,
            method: 'get'
        })
            .then(response => response.data)
            .catch(error => Promise.reject(error))
    );
};

export const ListCustomerInvoices = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/list/' + customer_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ListInvoices = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/list')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ListInvoicesPost = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/list', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SyncInvoiceData = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/sync_invoice_data', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ListInvoiceDrafts = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/list_drafts')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ListInvoiceOverdue = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/list_overdue')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ListInvoiceOpen = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/list_open')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const ListCreditInvoice = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/invoice/list_credit/${customer_id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const GetInvoiceLedgers = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/invoice_ledgers')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const GetInvoiceLedgersCustomer = (customer_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get(`/invoice/invoice_ledgers/${customer_id}`)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const InvoiceDetails = (invoice_id, history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/details/' + invoice_id)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const GetInvoiceStats = (history) => {
    return new Promise((resolve, reject) => {
        api
            .get('/invoice/get_invoice_stats')
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvocieReminder = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/reminder', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceAdd = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/add', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SearchInvoice = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/search', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const SearchCustomerInvoice = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post(`/invoice/search/${data.customer_id}`, data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceDownload = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/download_invoice', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const ExportInvoices = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/export', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const InvoiceAddDraft = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/add_draft', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};


export const CreateCreditInvoice = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .post('/invoice/create_credit_invoice', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceUpdate = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/invoice/update', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceSetPayment = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/invoice/set_payment', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceSend = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/invoice/send', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceSendReminder = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/invoice/sendreminder', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceSetStatus = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .put('/invoice/status', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};

export const InvoiceDelete = (data, history) => {
    return new Promise((resolve, reject) => {
        api
            .remove('/invoice/delete', data)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                api.apiErrorHandler(error, history);
                reject(error);
            })
    });
};